'use strict';

angular.module('PinMeTo.directives').directive('pmtFileManager', [
	'$stateParams',
	'pmtAlertService',
	'pmtPlanHatService',
	'Upload',
	'$timeout',
	'$http',
	'auth',
	'$i18next',
	'pmtLoggerService',
	'pmtMediaService',
	function (
		$stateParams,
		pmtAlertService,
		pmtPlanHatService,
		Upload,
		$timeout,
		$http,
		auth,
		$i18next,
		pmtLoggerService,
		pmtMediaService
	) {
		return {
			restrict: 'A',
			scope: {
				place: '=',
				selectedMultiple: '&',
				supportMultipleSelect: '@',
				isLink: '@',
				maxWidth: '@',
				maxHeight: '@',
				minWidth: '@',
				minHeight: '@',
				minDuration: '@',
				maxDuration: '@',
				maxFileSize: '@',
				minFileSize: '@',
				maxMediaQuantity: '<',
				aspectRatioText: '@',
				mediaType: '@',
				network: '@',
				maxVideoBitrate: '@',
				maxAudioBitrate: '@',
				type: '@',
				fileType: '@',
				aspect: '<',
				placeId: '@',
				isListings: '@',
				isStories: '@',
				isLinkedInCarousel: '@',
				videoCodecNames: '<',
				audioCodecNames: '<',
				maxAudioSampleRate: '@',
				frameRate: '<',
				noEditList: '@',
				numberOfMedia: '<',
				croppedSources: '<'
			},
			link: function (scope, element, attrs) {
				let siteName = auth.user.selectedSite.name;
				let offset = 0;
				scope.isEditing = scope.croppedSources?.length > 0;
				scope.siteName = siteName;
				scope.fileListLoading = true;
				scope.query = '';
				scope.selectedFiles = [];
				scope.filesShownHere = $i18next.t('general.media_upload.files_shown_here', { br: `<br>` });
				scope.openImageEditor = false;
				scope.mediaLimitReached = scope.numberOfMedia >= scope.maxMediaQuantity;
				scope.hasCurrentImage = false;
				scope.isCurrentImageLoading = false;
				scope.stories_aspect_ratio = $i18next.t('posts.draft.stories_aspect_ratio_uploader');

				const mediaValidator = pmtMediaService.Validator(scope);

				function checkLocationHasCurrentImage() {
					const placeId = $stateParams.placeId || scope.placeId;
					$http
						.get('api/' + siteName + '/place/' + placeId + '/networkmedia')
						.then(({ data }) => {
							const media = data.networkMedia[scope.network];
							return scope.type === 'profile' ? media.profileImage : media.coverImage;
						})
						.then(imageData => {
							if (imageData.mediaRef || imageData.url) {
								scope.hasCurrentImage = true;
							}
						})
						.catch(err => {
							const errMsg = err && err.message ? err.message : err && err.data ? err.data : err;
							pmtAlertService.alert({
								title: $i18next.t('general.media_upload.failed_getting_image'),
								body: errMsg,
								confirm: () => {
									pmtAlertService.close();
								}
							});
						});
				}

				if (scope.isListings && ($stateParams.placeId || scope.placeId)) {
					checkLocationHasCurrentImage();
				}

				const humanReadableTime = function (duration) {
					let hours = Math.floor(duration / 3600);
					let minutes = Math.floor((duration % 3600) / 60);
					let seconds = Math.floor((duration % 3600) % 60);
					let msg = '0';
					if (hours > 0) {
						msg = hours + 'h';
					}
					if (minutes > 0) {
						msg = msg === '0' ? minutes + 'min' : msg + ' ' + minutes + 'min';
					}
					if (seconds > 0) {
						msg = msg === '0' ? seconds + 'sec' : msg + ' ' + seconds + 'sec';
					}
					return msg;
				};
				const humanReadableFileSize = function (size) {
					const gb = Math.floor(size / 1024 / 1024 / 1024);
					if (gb > 0) {
						return gb + ' GB';
					}
					const mb = Math.floor(size / 1024 / 1024);
					if (mb > 0) {
						return mb + ' MB';
					}
					const kb = Math.floor(size / 1024);
					return kb + ' KB';
				};

				scope.maxFileSizeFormatted = (function () {
					// Make it a number (again)
					scope.maxFileSize = scope.maxFileSize - 0;
					return humanReadableFileSize(scope.maxFileSize);
				})();
				scope.minFileSizeFormatted = (() => {
					scope.minFileSize = scope.minFileSize - 0;
					if (scope.minFileSize > 0) {
						return humanReadableFileSize(scope.minFileSize);
					} else {
						return '';
					}
				})();

				scope.fileList = {
					files: []
				};
				if (scope.mediaType === 'video') {
					if (scope.fileType === 'mp4,mov') {
						scope.acceptFileTypes = '.mov,.mp4';
						scope.acceptFileTypesHint = '.mov,.mp4';
						scope.acceptFileTypesMov = 'mov';
						scope.acceptFileTypesMp4 = 'mp4';
						scope.mediaTypeCapital = $i18next.t('general.video_plain');

						scope.fileTypeTip = $i18next.t('general.media_upload.file_type_video', {
							mediaTypeCapital: scope.mediaTypeCapital,
							fileType: `<strong>${scope.acceptFileTypesMov}</strong>`,
							fileType2: `<strong>${scope.acceptFileTypesMp4}</strong>`
						});
					} else {
						scope.acceptFileTypes = '.gif,.avi,.m4v,.mkv,.mov,.mp4,.mpeg,.mpg,.ogv,.ts,.wmv,.webm';
						scope.acceptFileTypesHint = '';
						scope.acceptFileTypesMov = 'mov';
						scope.acceptFileTypesMp4 = 'mp4';
						scope.mediaTypeCapital = $i18next.t('general.video_plain');

						scope.fileTypeTip = $i18next.t(
							'general.media_upload.recommended_facebook_video_format',
							{
								mediaTypeCapital: scope.mediaType,
								videoFormat: `<strong>${scope.acceptFileTypesMov}</strong>`,
								videoFormat2: `<strong>${scope.acceptFileTypesMp4}</strong>`
							}
						);
					}
				} else {
					if (scope.fileType === 'jpg') {
						scope.acceptFileTypes = '.jpg,.jpeg';
						scope.acceptFileTypesHint = 'JPG';
						scope.mediaTypeCapital = $i18next.t('general.image_plain');
						scope.mediaType = 'image';
					} else if (scope.fileType === 'jpg,png') {
						scope.acceptFileTypes = '.jpg,.jpeg,.png';
						scope.acceptFileTypesHint = 'JPG or PNG';
						scope.mediaTypeCapital = $i18next.t('general.image_plain');
						scope.mediaType = 'image';
					} else {
						scope.acceptFileTypes = '.jpg,.jpeg,.png,.webp';
						scope.acceptFileTypesHint = 'JPG or PNG';
						scope.mediaTypeCapital = $i18next.t('general.image_plain');
						scope.mediaType = 'image';
					}
					scope.fileTypeTip = $i18next.t('general.media_upload.file_type_image', {
						mediaTypeCapital: scope.mediaType,
						fileTypeImage: `<strong>${scope.acceptFileTypesHint}</strong>`
					});
				}

				scope.mediaSize = $i18next.t('general.media_upload.media_size', {
					mediaTypeCapital: scope.mediaTypeCapital
				});
				scope.mediaSizeMax = $i18next.t('general.media_upload.media_size_max', {
					mediaTypeCapital: scope.mediaTypeCapital
				});

				scope.aspectRatio = $i18next.t('general.media_upload.aspect_ratio', {
					mediaTypeCapital: scope.mediaTypeCapital
				});

				scope.fileDuration = $i18next.t('general.media_upload.duration', {
					mediaTypeCapital: scope.mediaTypeCapital,
					minDuration: `<strong>${humanReadableTime(scope.minDuration)}</strong>`,
					maxDuration: `<strong>${humanReadableTime(scope.maxDuration)}</strong>`
				});

				scope.fileSizeMax = $i18next.t('general.media_upload.file_size_max', {
					mediaTypeCapital: scope.mediaTypeCapital,
					maxFileSizeFormatted: `<strong>${scope.maxFileSizeFormatted}</strong>`
				});

				scope.fileSizeMin = $i18next.t('general.media_upload.file_size_min', {
					mediaTypeCapital: scope.mediaTypeCapital,
					minFileSizeFormatted: `<strong>${scope.minFileSizeFormatted}</strong>`
				});

				const translatedMediaType = (video, image) => {
					return scope.mediaType === 'video'
						? $i18next.t(video).toLowerCase()
						: $i18next.t(image).toLowerCase();
				};

				scope.dropMedia =
					scope.mediaType === 'video'
						? $i18next.t('general.media_upload.drop_video')
						: $i18next.t('general.media_upload.drop_image');

				scope.searchPlaceholder = $i18next.t('general.media_upload.search_placeholder', {
					mediaType: translatedMediaType('general.videos', 'general.images')
				});

				scope.uploadButton = `${$i18next.t('general.upload')} ${translatedMediaType(
					'general.video_plain',
					'general.image_plain'
				)}`;

				scope.existingMedia = $i18next.t('general.media_upload.existing_media', {
					mediaType: translatedMediaType('general.video_plain', 'general.image_plain')
				});

				scope.selectFile = function (file) {
					if (scope.isListings) {
						file.selected = true;
						scope.selectedMultiple({ files: [file] });
					} else if (scope.supportMultipleSelect !== 'true') {
						// set all the other files to unselect because it's radio button
						scope.fileList.files.forEach(x => (x.selected = false));
						file.selected = true;
						scope.selectedFiles = [file];
					} else {
						file.selected = !file.selected;

						scope.selectedFiles = scope.fileList.files.reduce(
							(arr, x) => {
								if (x.selected && !scope.selectedFiles.find(m => m.url === x.url)) {
									arr.push(x);
								}
								return arr;
							},
							scope.selectedFiles.filter(x => x.selected && x.url !== file.url)
						);
						if (!scope.isListings) {
							if (scope.selectedFiles.length > scope.maxMediaQuantity - scope.numberOfMedia - 1) {
								scope.mediaLimitReached = true;
							} else {
								scope.mediaLimitReached = false;
							}
						}
					}
				};

				scope.onSelectedMultiple = arg => {
					if (arg) {
						// cancel
						scope.selectedMultiple(null);
						if (scope.openImageEditor) {
							pmtPlanHatService.track('Image Editor - cancel');
						}
					} else {
						scope.selectedMultiple({ files: scope.selectedFiles });
					}
				};

				function debounce(callback, wait, immediate = false) {
					let timeout = null;

					return function () {
						const callNow = immediate && !timeout;
						const next = () => callback.apply(this, arguments);

						if (timeout != null) {
							$timeout.cancel(timeout);
						}

						timeout = $timeout(next, wait);

						if (callNow) {
							next();
						}
					};
				}

				scope.searchQuery = debounce(searchText => {
					pmtPlanHatService.track('searchMedia', searchText);

					scope.skip = 0;
					scope.fileList.files = [];
					scope.fileListLoading = true;
					scope.query = searchText;

					scope.queryMoreFiles();
				}, 800);

				scope.skip = 0;
				let queryIndex = 0;
				scope.queryMoreFiles = debounce(() => {
					queryIndex += 1;
					const localQueryIndex = queryIndex;

					const params = { skip: scope.skip, search: scope.query };
					$http
						.get('api/' + siteName + '/media/' + scope.mediaType, { params })
						.then(function (res) {
							if (queryIndex !== localQueryIndex) {
								return;
							}

							scope.skip += res.data.data.length;
							res.data.data.forEach(scope.validateMedia);
							const selected = scope.selectedFiles.filter(v => v.selected).map(v => v._id);
							res.data.data.forEach(v => {
								if (selected.includes(v._id)) {
									v.selected = true;
								}
							});
							scope.fileList.files = scope.fileList.files.concat(res.data.data);

							scope.fileListLoading = false;
						})
						.catch(res => {
							const errMsg =
								res.data?.message ||
								res.data?.error?.message ||
								res.data ||
								res.message ||
								res.error?.message ||
								'Something unexpected happened. Please refresh or navigate to another page.';
							pmtLoggerService.exceptionHandler(errMsg, `get media/${scope.mediaType} failed`);
							pmtAlertService.alert({
								title: $i18next.t('general.error_occurred'),
								body: errMsg,
								confirm: () => {
									pmtAlertService.close();
								}
							});
						});
				}, 500);

				scope.selectCurrentImage = () => {
					const placeId = $stateParams.placeId || scope.placeId;
					scope.isCurrentImageLoading = true;
					$http
						.get('api/' + siteName + '/place/' + placeId + '/networkmedia')
						.then(({ data }) => {
							const media = data.networkMedia[scope.network];
							return scope.type === 'profile' ? media.profileImage : media.coverImage;
						})
						.then(imageData => {
							const match = scope.fileList.files.find(
								x => x.id === imageData.mediaRef || x.url === imageData.url
							);
							if (match) {
								scope.selectedMultiple({ files: [match] });
							} else {
								return $http
									.get('api/' + siteName + '/media/asset/' + imageData.mediaRef)
									.then(({ data }) => {
										scope.selectedMultiple({ files: [data.data] });
									})
									.catch(() => {
										throw new Error($i18next.t('general.media_upload.no_image_match'));
									});
							}
						})
						.then(() => {
							scope.isCurrentImageLoading = false;
						})
						.catch(err => {
							scope.isCurrentImageLoading = false;
							const errMsg = err && err.message ? err.message : err && err.data ? err.data : err;
							pmtAlertService.alert({
								title: $i18next.t('general.media_upload.failed_getting_image'),
								body: errMsg,
								confirm: () => {
									pmtAlertService.close();
								}
							});
						});
				};

				window.pmtPlanhatTrack = pmtPlanHatService.track.bind(pmtPlanHatService);

				window.pmtImageValidation = source => {
					scope.validateMedia(source);

					if (window.pmtEditedImages?.length) {
						scope.hasError = window.pmtEditedImages.some(src => src.error);
						scope.$apply();
					}

					return source.error;
				};

				scope.validateMedia = file => {
					// separate images and videos
					if (scope.mediaType === 'image') {
						const result = mediaValidator.validateImage(file);
						if (file.userAction) {
							if (scope.enableCropper && !scope.openImageEditor) {
								file.error = $i18next.t('posts.draft.cropping_required_warning');
							} else if (scope.openImageEditor) {
								file.error = $i18next.t('posts.draft.user_action_aspect_ratio');
							}
						}
						return result;
					} else {
						return mediaValidator.validateVideo(file);
					}
				};

				const shouldDisableSelection = file => {
					if (file.error && !scope.enableCropper) {
						return true;
					}
					if (file.metaData.width < scope.minWidth || file.metaData.height < scope.minHeight) {
						return true;
					}
					if (scope.minFileSize && file.size < scope.minFileSize) {
						return true;
					}
					if (scope.mediaType === 'image' && file.contentType === 'image/gif') {
						return true;
					}
					return false;
				};

				const uploadFile = (file, idx, filesCount) =>
					new Promise((resolve, reject) => {
						if (!file.size) {
							return reject(new Error($i18next.t('general.media_upload.file_size_zero')));
						}

						Upload.upload({ url: 'api/' + siteName + '/media', file: file })
							.progress(function (evt) {
								if (evt.loaded === evt.total) {
									scope.saving = true;
								} else {
									scope.saving = false;
									const percent = parseFloat((100.0 * evt.loaded) / (evt.total || 1)).toFixed(1);
									scope.progressPercentage =
										filesCount > 1 ? `${idx + 1}/${filesCount}: ${percent}%` : `${percent}%`;
								}
							})
							.success(function (data /*, status, headers, config*/) {
								if (data.success) {
									const fileData = {
										...data.data,
										isRecent: true
									};
									scope.validateMedia(fileData);
									if (fileData.userAction) {
										pmtPlanHatService.track('Image Editor - uploaded an image requiring cropper');
									}

									scope.fileList.files.unshift(fileData);
									scope.skip += 1;
									resolve(fileData);
								} else {
									reject(new Error(data.data));
								}
							})
							.error(function (/*data, status, config*/) {
								reject(new Error('File upload failed.'));
							});
					});

				scope.upload = async function (files) {
					if (!files?.length) {
						return;
					}
					try {
						const uploads = [];
						scope.showUploadingProgress = true;
						scope.uploadError = null;

						for (let i = 0; i < files.length; i++) {
							const file = files[i];
							uploads.push(await uploadFile(file, i, files.length));
						}
						let overMediaQuantityLimit =
							uploads.length + scope.numberOfMedia + scope.selectedFiles.length >
							scope.maxMediaQuantity;
						scope.showUploadingProgress = false;
						if (uploads.every(x => scope.validateMedia(x))) {
							if (scope.isListings) {
								uploads.forEach(x => (x.selected = !shouldDisableSelection(x)));
								scope.selectedMultiple({ files: uploads });
							} else if (!overMediaQuantityLimit) {
								uploads.forEach(x => !shouldDisableSelection(x) && scope.selectFile(x));
							}
						} else {
							if (scope.enableCropper && !overMediaQuantityLimit) {
								uploads.forEach(x => !shouldDisableSelection(x) && scope.selectFile(x));
							}
						}
						scope.$apply();
					} catch (e) {
						scope.uploadError = e.message || 'File upload failed.';
						scope.showUploadingProgress = false;
						scope.$apply();
					}
				};

				scope.enableCropper = scope.mediaType === 'image' && !scope.isListings;

				function cropImageInBackend(onlyForPreview, file) {
					let url = 'api/' + siteName + '/media/crop/';
					if (onlyForPreview) {
						url += '?onlyForPreview=true';
					}
					return $http.post(
						url,
						{
							url: file.url,
							name: file.name,
							cropData: {
								left: file.imgData.x,
								top: file.imgData.y,
								width: file.imgData.width,
								height: file.imgData.height
							}
						},
						{ responseType: onlyForPreview ? 'blob' : 'application/json' }
					);
				}

				window.pmtCropImage = file => {
					return cropImageInBackend(true, file).then(res => {
						return res.data;
					});
				};

				scope.cropNext = () => {
					scope.openImageEditor = true;
					const $container = document.getElementById('pinmeto-image-editor-container');
					const $editor =
						$container.getElementsByTagName('pinmeto-image-editor')[0] ??
						(() => {
							const tag = `<pinmeto-image-editor></pinmeto-image-editor>`;
							$container.innerHTML = tag;
							return $container.childNodes[0];
						})();

					$editor.setAttribute('sources', JSON.stringify(scope.selectedFiles));
					$editor.setAttribute('validation', 'pmtImageValidation');
					$editor.setAttribute('track', 'pmtPlanhatTrack');
					$editor.setAttribute('network', scope.network);
					$editor.setAttribute('is-stories', scope.isStories);
					$editor.setAttribute('offset', offset);
					$editor.setAttribute('crop-image-in-backend', 'pmtCropImage');
				};

				if (scope.croppedSources?.length > 0) {
					scope.selectedFiles = scope.croppedSources;
					scope.croppedSources.forEach((v, i) => {
						if (v.active) {
							offset = i;
						}
					});
					scope.cropNext();
				}
				scope.cropPrevious = async () => {
					scope.processing = true;
					await window.genCurrentCroppedImage();
					scope.openImageEditor = false;
					scope.selectedFiles = window.pmtEditedImages;
					scope.processing = false;

					scope.$apply();

					pmtPlanHatService.track('Image Editor - back select images');
				};

				scope.cropFinish = async () => {
					scope.processing = true;

					let withoutCropping = true;

					const responses = await Promise.all(
						(window.pmtEditedImages || []).map(editedImage => {
							const imgData = editedImage.imgData;
							if (!imgData) {
								return;
							}
							if (!editedImage.modified) {
								return;
							}

							withoutCropping = false;
							pmtPlanHatService.track('Image Editor - cropped an image');

							return cropImageInBackend(false, editedImage);
						})
					);

					scope.processing = false;

					if (responses.some(s => s?.data.success === false)) {
						pmtAlertService.alert({
							title: $i18next.t('general.add_image'),
							body: $i18next.t('general.failed_upload'),
							confirm: () => {
								pmtAlertService.close();
							}
						});
					} else {
						scope.openImageEditor = false;
						responses.forEach((res, i) => {
							// also need to validate image after cropping
							Object.assign(scope.selectedFiles[i], res?.data?.data);
							scope.validateMedia(scope.selectedFiles[i]);
						});
						scope.selectedMultiple({ files: scope.selectedFiles });

						pmtPlanHatService.track('Image Editor - finish crop');
						if (withoutCropping) {
							pmtPlanHatService.track('Image Editor - add without cropping');
						}
					}

					scope.$apply();
				};

				const revalidateFiles = () => {
					// Re-validate all files when size constraints change
					if (scope.fileList?.files?.length > 0) {
						scope.fileList.files.forEach(file => {
							scope.validateMedia(file);
						});
					}
				};

				attrs.$observe(
					'minWidth',
					function (newVal, oldVal) {
						if (newVal == null || newVal === oldVal) {
							return;
						}
						scope.minWidth = scope.$eval(newVal);
						scope.selectMinWidth = scope.minWidth;
						revalidateFiles();
					},
					true
				);

				attrs.$observe(
					'minHeight',
					function (newVal, oldVal) {
						if (newVal == null || newVal === oldVal) {
							return;
						}
						scope.minHeight = scope.$eval(newVal);
						scope.selectMinHeight = scope.minHeight;
						revalidateFiles();
					},
					true
				);

				attrs.$observe(
					'maxWidth',
					function (newVal, oldVal) {
						if (newVal == null || newVal === oldVal) {
							return;
						}
						scope.maxWidth = scope.$eval(newVal);
						scope.selectMaxWidth = scope.maxWidth;
						revalidateFiles();
					},
					true
				);
				attrs.$observe(
					'maxHeight',
					function (newVal, oldVal) {
						if (newVal == null || newVal === oldVal) {
							return;
						}
						scope.maxHeight = scope.$eval(newVal);
						scope.selectMaxHeight = scope.maxHeight;
						revalidateFiles();
					},
					true
				);
			},
			templateUrl: 'pmtShared/filemanager/pmtFileManagerView.html'
		};
	}
]);
